export default __webpack_public_path__ + "static/media/hidraulica-thanks.7d67df34.png";